(function ($) {
    // $(document).ready(function () {
    //     if ($('.image-tabs').length > 0) {
    //         $(".image-tabs .tab-content").hide().first().show();
    //         $(".image-tabs .tab-item h5").click(function () {
    //             var index = $(this).parent().index();
    //             $(".tab-content").hide();
    //             $(".tab-content").eq(index).show().siblings().hide();


    //         })
    //         $(".image-tabs .tab-item h5").hover(function () {
    //             $(this).trigger("click");
    //         })
    //     }
    // });

    function numberToWords(number) {
        var digit = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        var elevenSeries = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        var countingByTens = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        var shortScale = ['', 'thousand', 'million', 'billion', 'trillion'];
        number = number.toString();
        number = number.replace(/[\, ]/g, '');
        if (number != parseFloat(number)) return 'not a number';
        var x = number.indexOf('.');
        if (x == -1) x = number.length;
        if (x > 15) return 'too big';
        var n = number.split('');
        var str = '';
        var sk = 0;
        for (var i = 0; i < x; i++) {
            if ((x - i) % 3 == 2) {
                if (n[i] == '1') {
                    str += elevenSeries[Number(n[i + 1])] + ' ';
                    i++;
                    sk = 1;
                } else if (n[i] != 0) {
                    str += countingByTens[n[i] - 2] + ' ';
                    sk = 1;
                }
            } else if (n[i] != 0) {
                str += digit[n[i]] + ' ';
                if ((x - i) % 3 == 0) str += 'hundred ';
                sk = 1;
            }
            if ((x - i) % 3 == 1) {
                if (sk) str += shortScale[(x - i - 1) / 3] + ' ';
                sk = 0;
            }
        }
        if (x != number.length) {
            var y = number.length;
            str += 'point ';
            for (var i = x + 1; i < y; i++) str += digit[n[i]] + ' ';
        }
        str = str.replace(/\number+/g, ' ');
        str = str.replace(/\s+/g, '').toLowerCase();
        return "section-tab-" + str.trim() + "";
    }

    $(window).on("load", function () {

        var sectionName = $(".image-tabs"),
            liBtn = ".image-tabs .row-wrap .col-two .tabs-wrapper .tab-item",
            currentitemId = $(".image-tabs .row-wrap .col-two .tab-item.active").attr("data-id"),
            lastItemId, firstitemId,
            index = 1, id = 0;
        sectionName.css('opacity', 1);
        sectionName.each(function () {
            var className = numberToWords(index);
            $(this).addClass(className);
            id = index + "01";
            $(".image-tabs." + className + " .row-wrap .col-two .tabs-wrapper .tab-item").each(function () {
                $(this).attr("data-id", id);
                id++;
            });
            id = index + "01";
            $(".image-tabs." + className + " .row-wrap .col-two .tab-content .tab-item").each(function () {
                $(this).attr("id", id);
                id++;
            });
        });
        
        //Li Click
        $(document).delay(200).on("click", liBtn, function () {
            firstitemId = $(this).parent().find(":first-child").attr("data-id");
            lastItemId = $(this).parent().find(".tab-item:last-child").attr("data-id");
            // $(this).find('.tab-item:first-of-type').addClass('active');

            var itemId = $(this).attr("data-id");
            currentitemId = itemId;
            $(this).addClass("active");
            $(".image-tabs .row-wrap .col-two .tab-content .tab-item#" + itemId).prevAll().removeClass('active').removeAttr("style");
            $(".image-tabs .row-wrap .col-two .tab-content .tab-item#" + itemId).nextAll().removeClass('active').removeAttr("style");
            $(".image-tabs .row-wrap .col-two .tab-content .tab-item#" + itemId).addClass('active');
        });

        $(' .image-tabs .row-wrap .col-two .tabs-wrapper .tab-item').hover(function () {
            $(this).parent().find('.tab-item:first-of-type').addClass('active');
            $(this).parent().find('.tab-item:first-of-type').removeClass('active');
            $(this).parent().find('.tab-item:not(:first-of-type)').removeClass('active');
        });

        $('.image-tabs .row-wrap .col-two .tab-content .tab-item:first-of-type').addClass('active');

        $(".image-tabs .tab-item").hover(function () {
            $(this).trigger("click");
        })
    });
})(jQuery);


